import React from 'react';
import CrudManager from '@/components/admin/CrudManager';

const AdminArticles = () => (
  <CrudManager
    title="Knowledge Hub Articles"
    subtitle="Blog posts, foundational explainers, seasonal wellness — the educational library."
    endpoint="/admin/articles"
    idField="slug"
    useKeyInPath
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'slug', label: 'Slug' },
      { key: 'category', label: 'Category' },
      { key: 'reading_time', label: 'Read time', render: (a) => `${a.reading_time} min` },
      { key: 'published', label: 'Published', render: (a) => a.published ? '✓' : '—' },
    ]}
    initial={{ slug: '', title: '', excerpt: '', category: 'Foundations', reading_time: 5, cover_image: '', body: '', published: true, seo_title: '', seo_description: '' }}
    fields={[
      { key: 'slug', label: 'Slug (URL)', required: true, placeholder: 'gut-health-classical-view' },
      { key: 'title', label: 'Title', required: true },
      { key: 'excerpt', label: 'Excerpt (shown on card)', type: 'textarea', rows: 2 },
      { key: 'category', label: 'Category', help: 'e.g. Foundations, Body Systems, Lifestyle, Recipes, Women\'s Health' },
      { key: 'reading_time', label: 'Reading time (min)', type: 'number' },
      { key: 'cover_image', label: 'Cover image URL' },
      { key: 'body', label: 'Body (Markdown-lite; \\n\\n for paragraphs)', type: 'textarea', rows: 10 },
      { key: 'published', label: 'Published', type: 'checkbox' },
      { key: 'seo_title', label: 'SEO title (optional)' },
      { key: 'seo_description', label: 'SEO description', type: 'textarea', rows: 2 },
    ]}
  />
);

export default AdminArticles;
